import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { mapEducation } from '../../reducers/educationReducer';
import { fetchEducationIfNeeded, fetchEducation } from '../../actions/education';
import EditPanel from './EditPanel';

const Education = ({
  educationData,
  showErrorMessage,
  errorMessage,
  loaded,
  EmployeeMasterID,
  dispatch,
}) =>
  (<EditPanel
    title={<FormattedMessage id="education.title" />}
    emptyText="education.empty"
    loaded={loaded}
    showErrorMessage={showErrorMessage}
    errorMessage={errorMessage}
    onOpen={() => dispatch(fetchEducationIfNeeded())}
    modelName="EmployeeMasterEducation"
    dataSource={educationData}
    mapModel={mapEducation}
    EmployeeMasterID={EmployeeMasterID}
    fetchData={fetchEducation}
  />);

function mapStateToProps(state) {
  return {
    loaded: state.educationReducer.loaded,
    educationData: state.educationReducer.educationData,
    form: state.form.EmployeeMasterEducation,
    EmployeeMasterID: state.loginReducer.user.EmployeeMasterID,
    showErrorMessage: ((state.educationReducer.error && state.educationReducer.error.Message.length) > 0),
    errorMessage: (state.educationReducer.error && state.educationReducer.error.Message) || '',
  };
}

Education.propTypes = {
  loaded: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
  educationData: PropTypes.array,
  showErrorMessage: PropTypes.bool,
  errorMessage: PropTypes.string,
  EmployeeMasterID: PropTypes.number,
};

export default connect(mapStateToProps)(Education);



// WEBPACK FOOTER //
// ./src/components/profile/Education.js